// extracted by mini-css-extract-plugin
export default {"trigger":"trigger-t4wbh","popover":"popover-BooAt","instrumentOption":"instrumentOption-JPQJy","instrumentImage":"instrumentImage-V8uO8","instrumentType":"instrumentType-tulkz"};